import { Box, styled, useTheme } from "@mui/material"
import type { PropsWithChildren } from "react"

type Conf = { accentColor: string }
const propsConf: (keyof Conf)[] = ["accentColor"]

export const FinancialSummaryTitleCard = ({ children }: PropsWithChildren) => {
  const conf = useConf()
  return (
    <Card {...conf}>
      <ContentContainer>{children}</ContentContainer>
      <Dash {...conf} />
    </Card>
  )
}

export const FinancialSummaryTitleCardMini = ({ children }: PropsWithChildren) => {
  const conf = useConf()
  return <CardMini {...conf}>{children}</CardMini>
}

const useConf = (): Conf => ({
  accentColor: useTheme().palette.brandingAccent.dark2,
})

const tint = (color: string, pct: number) =>
  `color-mix(in srgb, ${color} ${pct}%, #fff)`

const BaseCard = styled(Box, {
  shouldForwardProp: (prop) => !propsConf.includes(String(prop)),
})<Conf>(({ theme: { spacing }, accentColor }) => ({
  backgroundColor: `${tint(accentColor, 17.5)}`,
  border: "1px solid",
  borderColor: `${tint(accentColor, 28.5)}`,
  borderRadius: spacing(0.75),
  cornerShape: "squircle",
  width: "fit-content",
}))

const Card = styled(BaseCard)(({ theme: { spacing } }) => ({
  display: "grid",
  placeContent: "center",
  padding: spacing(3.75),
  height: "100%",
}))

const CardMini = styled(BaseCard)(({ theme: { spacing } }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: spacing(2.5),
  paddingBlock: spacing(0.75),
  paddingInline: spacing(1.5),
}))

const ContentContainer = styled(Box)(({ theme: { spacing } }) => ({
  display: "flex",
  flexDirection: "column",
  gap: spacing(1.5),
}))

const Dash = styled(Box, {
  shouldForwardProp: (prop) => !propsConf.includes(String(prop)),
})<Conf>(({ theme: { spacing }, accentColor }) => ({
  border: "1px solid",
  borderColor: accentColor,
  borderRadius: spacing(1),
  width: "65px",
  marginTop: spacing(2.5),
}))
